/**
 * @fileoverview This domain provides translations for SBI.
 */

import { get, set } from 'microcosm'
import RA from 'ra-config'

import { filterRegion } from '../actions/ui'

class Locale {
  getInitialState() {
    return RA.app
  }

  /**
   * The ITD translation needs to be dynamic, based upon the current
   * region in UI state.
   */
  updateITD(locale, region) {
    let inceptionDate = get(RA, `app.page.regions.${region.value}.ITD`)

    return set(locale, 'ITD', inceptionDate)
  }

  register() {
    return {
      [filterRegion]: this.updateITD
    }
  }
}

export default Locale



// WEBPACK FOOTER //
// ./src/domains/locale.js